import "./PropertyInformation.scss";

import { Accordion } from "components/Accordion";
import { DescriptionItem } from "components/DescriptionItem";
import { ReactComponent as BabyIcon } from "assets/icons/baby.svg";
import { ReactComponent as DropIcon } from "assets/icons/drop.svg";
import { ReactComponent as FireIcon } from "assets/icons/fire.svg";
import { ReactComponent as FrostIcon } from "assets/icons/frost.svg";
import { ReactComponent as FanIcon } from "assets/icons/propeller.svg";

import { NewAmenities } from "components/StayDetails/Sections/NewAmenities";

export const Utilities = ({ property }) => {
  const homeInfo = property?.home_info;
  const maintenance = homeInfo?.maintenance;

  if (!homeInfo || !maintenance) {
    return null;
  }

  const {
    air_conditioning_control_location:
      airConditioningControlLocation,
    air_conditioning_notes: airConditioningNotes,
    air_conditioning_control_type:
      airConditioningControlType,
    heating_control_location: heatingControlLocation,
    heating_notes: heatingNotes,
    heating_control_type: heatingControlType,
    hot_water_notes: hotWaterNotes
  } = maintenance;

  const {
    baby_cot_notes: babyCotNotes,
    portable_fan_notes: portableFanNotes
  } = homeInfo;

  const heatingItems = [
    heatingControlLocation,
    heatingControlType,
    heatingNotes
  ];

  const airConditioningItems = [
    airConditioningControlLocation,
    airConditioningControlType,
    airConditioningNotes
  ];

  return (
    <Accordion title="Utilities">
      <ul className="PropertyInformation__list">
        {heatingItems.some(el => el) && (
          <li className="PropertyInformation__item">
            <span className="PropertyInformation__heading small-header">
              <FireIcon className="PropertyInformation__icon" />
              Heating
            </span>

            {heatingControlLocation && (
              <DescriptionItem
                title="Heating control location"
                content={heatingControlLocation}
              />
            )}

            {heatingControlType && (
              <DescriptionItem
                title="Heating control type"
                content={heatingControlType}
              />
            )}

            {heatingNotes && (
              <DescriptionItem
                title="Heating notes"
                content={heatingNotes}
              />
            )}
          </li>
        )}

        {hotWaterNotes && (
          <li className="PropertyInformation__item">
            <span className="PropertyInformation__heading small-header">
              <DropIcon className="PropertyInformation__icon" />
              Hot water
            </span>

            <span className="PropertyInformation__text">
              {hotWaterNotes}
            </span>
          </li>
        )}

        {airConditioningItems.some(el => el) && (
          <li className="PropertyInformation__item">
            <span className="PropertyInformation__heading small-header ">
              <FrostIcon className="PropertyInformation__icon" />
              Air conditioning
            </span>

            {airConditioningControlLocation && (
              <DescriptionItem
                title="Air conditioning control location"
                content={airConditioningControlLocation}
              />
            )}

            {airConditioningControlType && (
              <DescriptionItem
                title="Air conditioning control type"
                content={airConditioningControlType}
              />
            )}

            {airConditioningNotes && (
              <DescriptionItem
                title="Air conditioning notes"
                content={airConditioningNotes}
              />
            )}
          </li>
        )}

        {portableFanNotes && (
          <li className="PropertyInformation__item">
            <span className="PropertyInformation__heading small-header ">
              <FanIcon className="PropertyInformation__icon" />
              Portable fan
            </span>

            <span className="PropertyInformation__text">
              {portableFanNotes}
            </span>
          </li>
        )}

        {babyCotNotes && (
          <li className="PropertyInformation__item">
            <span className="PropertyInformation__heading small-header ">
              <BabyIcon className="PropertyInformation__icon" />
              Baby cot
            </span>

            <span className="PropertyInformation__text">
              {babyCotNotes}
            </span>
          </li>
        )}

        <NewAmenities propertyId={property.id} />
      </ul>
    </Accordion>
  );
};
